import { i as integer } from './index-d82d90ab.js';
import { b0 as text } from './index-269488d0.js';

const cloudImageSchema = {
  src: text({
    label: 'URL',
    validation: {
      length: {
        min: 1
      }
    }
  }),
  alt: text({
    label: 'Alt text'
  }),
  height: integer({
    label: 'Height'
  }),
  width: integer({
    label: 'Width'
  })
};

export { cloudImageSchema as c };
